import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const projects = [
  {
    id: 1,
    title: "Multistate Informative Website",
    description:
      "Fully responsive, SEO-friendly multipage platform with seamless user experience.",
    client: " Multistate Co-op. Urban Credit Society",
    link: "#",
  },
  {
    id: 2,
    title: "E-Commerce Website",
    description:
      "Modern online store with payment integration and user-friendly design.",
    client: "ABC Retail Pvt Ltd",
    link: "#",
  },
  {
    id: 3,
    title: "School Management System",
    description:
      "Complete system for managing students and academic records.",
    client: "XYZ School",
    link: "#",
  },
  {
    id: 4,
    title: "Portfolio Website",
    description:
      "Modern portfolio with responsive and clean UI.",
    client: "Freelancer Client",
    link: "#",
  },
];

function Portfolio() {
  return (
    <div style={{ background: "#EEEEEE"}}>

      {/* Header (Same as Careers) */}
     <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Our Portfolio</h2>
                            <h5 style={{'color':'white'}}>“Explore our work — where ideas turn into powerful digital solutions.”</h5>
                        </div>
                       
                    </div>
                </div>
            </div>

      {/* Portfolio Cards (Same style as Careers cards) */}
      <div className="container-fluid pb-5">
        <div className="row g-4">

          {projects.map((project, index) => (
  <div className="col-md-6 col-lg-4" key={project.id}>
    
    <div
      className="p-4 h-100 portfolio-card fade-in"
      style={{
        animationDelay: `${index * 0.2}s`,
        borderRadius: "16px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.05)",
      }}
    >
                {/* Title */}
                <h5 className="text-dark fw-bold">{project.title}</h5>

                {/* Description */}
                <p className="text-secondary small mt-2">
                  {project.description}
                </p>

                {/* Client */}
                <p className="mt-2" style={{ color: "#f43f5e", fontWeight: 500 }}>
                  by {project.client}
                </p>


          <div className="row">
              <div className="col-lg-6 col-6">
              <a
                    href="#"
                    className="btn me-2"
                    style={{
                      background:
                        "linear-gradient(45deg,#ef4444,#dc2626)",
                      color: "#fff",
                      borderRadius: "8px",
                    }}
                  >
                    ↳ View Details
                  </a></div>
              <div className="col-lg-6 col-6">
               <a
                    href={project.link}
                    className="btn"
                    style={{
                      background:
                        "linear-gradient(45deg,#1e293b,#020617)",
                      color: "#fff",
                      borderRadius: "8px",
                    }}
                  >
                    🔗 Visit Site
                  </a>
                </div>
              </div>
             


               
              </div>

            </div>
          ))}

        </div>
      </div>

    </div>
  );
}

export default Portfolio;
